@if (isLoading$ | async) {
  <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
}
